module.exports = __webpack_public_path__ + "static/media/wallfinishes_lcs_60y_y.b8c35f7a.csv";